// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__QMccy","errorCard":"Error_errorCard__mQmnY","errorTitle":"Error_errorTitle__+FcJy","errorMessage":"Error_errorMessage__tYIJx"};